module.exports = __webpack_public_path__ + "d460cf599eafda0ce69e2a1a9c6c6a69.pdf";